export default __webpack_public_path__ + "static/funnel-dark-d05bf7eb7ffea28b5e6335fffb6ed10c.png";